<template lang="pug">
v-container(
  fluid
  id="website-theme-preview"
  fill-height
  class=" tw-p-0 tw-m-0  tw-items-start tw-content-start tw-overflow-x-hidden"
)
  kubiqa-website-themes-theme-f-components-shared-top-navigation(
    changeOnScroll="false"
    titleColor="tw-text-white"
    appBarBg="tw-bg-cyan-darken-3 tw-rounded-full tw-opacity-75"
  )
  v-row(justify="center")
    v-col(cols="11" class="theme-f-carousel-container")
      kubiqa-website-themes-theme-f-components-shared-carousel(:images="images" class="tw-w-full tw-relative tw-z-10 ")
  div(class="d-flex flex-row tw-mx-auto tw-flex-wrap tw-min-h-full  tw-content-start tw-mt-12 tw-w-full tw-bg-gray-lighten-4 ")
    v-container(fluid class=" tw-bg-white tw-my-12 tw-rounded-md tw-w-11/12 tw-px-10")
      v-row(justify="center" class="tw-py-8")
        // Right column
        v-col(cols="8" xl="9")
          v-row
            v-col(cols="9" xl="10")
              div
                span(class="tw-text-3xl tw-font-bold") {{ this.$faker().lorem.sentence(3) }}
              div(class="tw-pt-2")
                v-icon(color="text-secondary") mdi-map-marker-outline
                span(class="tw-text-lg ") {{ this.$faker().address.streetAddress(true) }}, {{ this.$faker().address.county() }}, {{ this.$faker().address.stateAbbr() }}
            v-col(cols="3" xl="2")
              v-row(justify="end")
                v-col(cols="auto")
                  div(class="text-right tw-text-gray-darken-1")
                    span(class="tw-text-md tw-font-bold") {{ this.$faker().random.arrayElement(['Rent', 'Sale']) }}
                  div(class="tw-pt-2")
                    span(class="tw-text-2xl tw-font-bold") ${{ this.$faker().finance.amount(10000, 100000, 0) }}
              v-row(justify="end" class="tw--mt-6 tw-py-0 tw-my-0")
                v-col(cols="auto")
                  v-btn(outlined color="black" @click="method")
                    v-icon mdi-share-variant
                    span SHARE
          // Description
          v-row
            v-col
              div
                span(class=" tw-text-xl tw-font-bold") Description
              div(class="tw-pt-2")
                span {{ this.$faker().lorem.paragraphs(3) }}
          //Details
          v-row(class="tw-pt-4")
            v-col
              v-row
                v-col
                  span(class="tw-text-xl tw-font-bold") Details
              v-row
                v-col
                  span 1 bedroom
                v-col
                  span 2 bathroom
                v-col
                  span 220 m2

          v-row
            v-col(class="")
              span(class="tw-text-xl tw-font-bold") Amenities
          v-row
            v-col
              div(class="tw-py-2")
                div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                  v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
              div(class="tw-py-2")
                div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                  v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
              div(class="tw-py-2")
                div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                  v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
            v-col
              div(class="tw-py-2")
                div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                  v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
              div(class="tw-py-2")
                div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                  v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
              div(class="tw-py-2")
                div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                  v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
            v-col
              div(class="tw-py-2")
                div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                  v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
              div(class="tw-py-2")
                div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                  v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
              div(class="tw-py-2")
                div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                  v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}

          // Map
          v-row(class="tw-pt-4")
            v-col
              div
                span(class="tw-text-xl tw-font-bold") Map
              div(class=" tw-pt-2")
                kubiqa-misc-map
        v-col(cols="" class="")
          v-row(no-gutters justify="center")
            v-col(cols="")
              v-container(class="tw-border tw-border-gray-lighten-2 tw-overflow-hidden tw-rounded-md")
                v-row(class="")
                  v-col
                    span(class=" tw-text-gray-darken-1 tw-font-extrabold tw-text-2xl") Contact
                v-row
                  v-col
                    v-text-field(label="Name" outlined hide-details)
                v-row
                  v-col
                    v-text-field(label="Last Name" outlined hide-details)
                v-row
                  v-col
                    v-text-field(label="Phone" outlined hide-details)
                v-row
                  v-col
                    v-text-field(label="Email" outlined hide-details)
                v-row(class="tw-pb-0")
                  v-col
                    v-textarea(label="Message" outlined hide-details)
                v-row(class="tw-pt-0")
                  v-col(class="py-0")
                    v-btn(x-large block elevation="0" color="red darken-3")
                      span(class=" tw-font-bold tw-text-xl") SEND

  //Similar properties
  v-row(justify="center" class="tw-pt-6 ")
    v-col(cols="10")
      div(class="tw-pb-6")
        span(class=" tw-text-xl tw-font-bold") More listings
      div(class="d-flex flex-row flex-wrap tw-mx-auto tw-pb-6")
        div(v-for="item in 3" :key="item.id" class=" tw-w-1/3 tw-mx-0 tw-px-2 ")
          kubiqa-website-themes-theme-f-components-shared-listing-card

        // Left column

  kubiqa-website-themes-theme-f-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      images: [],
    };
  },
  created() {
    for (let index = 0; index < 20; index++) {
      var image = {};

      image.description = this.$faker().lorem.sentence();
      const img = new Image();
      image.href = image.src = 'https://picsum.photos/seed/' + this.$faker().datatype.number(5) + '/650/450';
      this.images.push(image);
    }
  },
};
</script>
